import { gql } from '@apollo/client'

export type { CombinedHarvestStats, CombinedHarvestStatsVariables } from './types/index.graphql'

export const GET_COMBINED_HARVEST_STATS = gql`
  query CombinedHarvestStats(
    $seasonStartRange: DateTime
    $seasonEndRange: DateTime
    $cropId: Int!
    $varietyId: Int
    $regionId: Int
    $subregionId: Int
    $companyId: Int
    $timeMode: AnalyticsTimeMode
    $status: [RiceLotStatus!]
  ) {
    currentHarvestStats: organizationCurrentAnalyticsSummary(
      seasonStartRange: $seasonStartRange
      seasonEndRange: $seasonEndRange
      cropId: $cropId
      varietyId: $varietyId
      regionId: $regionId
      subregionId: $subregionId
      companyId: $companyId
    ) {
      companies {
        lotsStats {
          harvestDate {
            lots
            size
          }
        }
        company {
          id
          name
        }
        totals {
          lots
          size
        }
      }
    }
    nextTwoWeeksHarvestStats: organizationAnalytics(
      seasonStartRange: $seasonStartRange
      seasonEndRange: $seasonEndRange
      cropId: $cropId
      varietyId: $varietyId
      regionId: $regionId
      subregionId: $subregionId
      companyId: $companyId
      timeMode: $timeMode
      status: $status
    ) {
      companiesSummary {
        company {
          id
          name
        }
        totals {
          lots
          size
        }
      }
    }
  }
`
